import React from 'react';
import { Alert, AlertTitle, styled } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

interface SuccessAlertProps {
  title?: string;
  message: string;
  onClose?: () => void;
  showIcon?: boolean;
}

const StyledSuccessAlert = styled(Alert)({
  borderRadius: '12px',
  padding: '16px 20px',
  marginBottom: '20px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  backdropFilter: 'blur(10px)',
  background: 'linear-gradient(145deg, #e8f5e8, #f0f8f0)',
  color: '#166534',
  border: '1px solid rgba(22, 101, 52, 0.2)',
  overflow: 'visible',
  maxHeight: 'none',
  '& .MuiAlert-icon': {
    fontSize: '24px',
    color: '#166534',
  },
  '& .MuiAlert-message': {
    padding: '0',
    overflow: 'visible',
    maxHeight: 'none',
  },
  '& .MuiAlertTitle-root': {
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: '4px',
    overflow: 'visible',
  },
  '& .MuiAlert-description': {
    fontSize: '14px',
    lineHeight: 1.5,
    overflow: 'visible',
    wordWrap: 'break-word',
  },
});

export const SuccessAlert: React.FC<SuccessAlertProps> = ({
  title,
  message,
  onClose,
  showIcon = true,
}) => {
  return (
    <StyledSuccessAlert
      severity="success"
      icon={showIcon ? <CheckCircleOutlineIcon /> : null}
      onClose={onClose}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {message}
    </StyledSuccessAlert>
  );
};